import AppConfigs from 'general/constants/AppConfigs';
import axiosClient from './axiosClient';

const feApi = {
  register: (params) => {
    const url = '/fe/register';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  signIn: (params) => {
    const url = '/fe/login';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getProfile: () => {
    const url = '/fe/profile';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  topUpWallet: (params = {}) => {
    const url = '/fe/topup';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  updateProfile: (params = {}) => {
    const url = '/fe/profile';
    return axiosClient.put(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  verifyReferralCode: (code) => {
    const url = '/fe/referral-code/verify';
    return axiosClient.get(url, {
      params: { code },
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  checkReferralCode: (code) => {
    const url = '/fe/referral-code/check';
    return axiosClient.get(url, {
      params: { code },
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  updateReferralCode: (referralCode) => {
    const url = '/fe/referral-code';
    return axiosClient.put(url, { referralCode }, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getProducts: (params = {}) => {
    const url = '/fe/products';
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getOrders: (params = {}) => {
    const url = '/fe/orders';
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  createOrder: (params = {}) => {
    const url = '/fe/orders';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getOrderPaymentQR: (saleId) => {
    const url = `/fe/orders/${saleId}/payment-qr`;
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getAffiliateSummary: () => {
    const url = '/fe/affiliate/summary';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getAffiliateNetworkSummary: () => {
    const url = '/fe/affiliate/network/summary';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getAffiliateNetworkDirectMembers: (params = {}) => {
    const url = '/fe/affiliate/network/direct-members';
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getAffiliateNetworkMemberTree: (userId, params = {}) => {
    const url = `/fe/affiliate/network/members/${userId}/tree`;
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  createAffiliateWithdrawal: (params = {}) => {
    const url = '/fe/affiliate/withdrawals';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  withdraw: (params = {}) => {
    const url = '/fe/withdraw';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getMarketingDocuments: (params = {}) => {
    const url = '/fe/marketing-documents';
    return axiosClient.get(url, {
      params: { ...params, publishedOnly: 1 },
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getNotifications: (params = {}) => {
    const url = '/fe/notifications/my';
    return axiosClient.get(url, {
      params,
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  readAllNotifications: () => {
    const url = '/fe/notifications/readAll';
    return axiosClient.post(url, {}, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  bulkNotifications: (action, notificationIds) => {
    const url = '/fe/notifications/bulk';
    return axiosClient.post(url, { action, notificationIds }, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  updateNotification: (notificationId, params = {}) => {
    const url = `/fe/notifications/${notificationId}`;
    return axiosClient.put(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // lay thong tin chi tiet voi sac
  getChargeConnectorDetail: (chargeConnectorId) => {
    const url = `/fe/connector/${chargeConnectorId}`;
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  activateChargeByQR: (params = {}) => {
    const url = '/fe/activateChargerByQR';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  deactivateCharge: (params = {}) => {
    const url = '/fe/deactivateCharger';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  checkPaymentStatus: (params = {}) => {
    const url = '/fe/payment';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getBrandList: (params = {}) => {
    const url = '/fe/carBrands';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getModelList: (params = {}) => {
    const url = '/fe/carModels';
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // quen mat khau
  requestForgotPassword: (email) => {
    const url = '/fe/forgot';
    const params = {
      email: email,
    };
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // dat lai mat khau
  resetPassword: (email, token, newPassword) => {
    const url = '/fe/reset';
    const params = {
      email,
      token,
      newPassword,
    };
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  getTransactionDetail: (params = {}) => {
    const url = '/fe/transaction';
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // lay thong tin chi tiet the rfid
  getTopupCard: (params) => {
    const url = `/fe/getTopupCard`;
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },

  // nap tien qua ma qr
  topupCard: (params) => {
    const url = `/fe/topupCard`;
    return axiosClient.post(url, params, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },
};

export default feApi;
